module.exports = __webpack_public_path__ + "dashboard/img/pipe.8a886c62a154d55c702fa6175647530f.svg";